<div fxLayoutAlign="center center" fxFlex fxFlexFill fxFlexLayout="column" class="container-fluid">
  <div class="state">
    <div class="card" class="fxGap-medium-sm">
      <div class="card-body" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="center center"><h1>Confirm selections</h1></div>
        <div *ngIf="hasMedical && medicalChange?.planMessage && medicalChange?.planMessage !== ''">
          <h2 style="text-align: center">Medical Selection Message</h2>
          <div fxFlexFill class="info-container" style="overflow: auto; height: 300px">
            <span [innerHTML]="(isSelfPay && medicalChange?.planMessageSelfPay ? medicalChange?.planMessageSelfPay : medicalChange?.planMessage)"></span>
          </div>
        </div>
        <div *ngIf="hasDental && dentalChange?.planMessage && dentalChange?.planMessage !== ''">
          <h2 style="text-align: center">Dental Selection Message</h2>
          <div fxFlexFill class="info-container" style="overflow: auto; height: 300px">
            <span [innerHTML]="(isSelfPay && dentalChange?.planMessageSelfPay ? dentalChange?.planMessageSelfPay : dentalChange?.planMessage)"></span>
          </div>
        </div>
        <div *ngIf="hasVision">
          <h2 style="text-align: center">Vision Selection Message</h2>
          <div fxFlexFill class="info-container" style="overflow: auto; height: 300px">
            <span [innerHTML]="(isSelfPay && visionChange?.planMessageSelfPay ? visionChange?.planMessageSelfPay : visionChange?.planMessage)"></span>
          </div>
        </div>
        <div>
          <h2 style="text-align: center" class="mobile-text-centered">Please review the information below</h2>
          <h3 class="h4" style="text-align: center">If correct, select Confirm. To make a change, select previous.</h3>
        </div>
        <div fxLayoutAlign="center">
          <div fxFlexLayout="column">
            <ul class="hca-ordered-list">
              <li *ngIf="hasMedical && subscriberSummary.effectiveMedicalPlan !== subscriberMedicalPlanName">
                You requested to change {{ inAdminState ? "this subscriber's" : 'your' }} medical plan from {{ subscriberSummary.effectiveMedicalPlan }} to {{ subscriberMedicalPlanName }}.
              </li>
              <li *ngIf="hasMedical && subscriberSummary.effectiveMedicalPlan == subscriberMedicalPlanName">
                You have not made changes to {{ inAdminState ? "this subscriber's" : 'your' }} medical plan.
              </li>
              <li *ngIf="hasDental && subscriberSummary.effectiveDentalPlan !== subscriberDentalPlanName">
                You requested to change {{ inAdminState ? "this subscriber's" : 'your' }} dental plan from {{ subscriberSummary.effectiveDentalPlan }} to {{ subscriberDentalPlanName }}.
              </li>
              <li *ngIf="hasDental && subscriberSummary.effectiveDentalPlan == subscriberDentalPlanName">You have not made changes to {{ inAdminState ? "this subscriber's" : 'your' }} dental plan.</li>

              <li *ngIf="hasVision && subscriberSummary.effectiveVisionPlan !== subscriberVisionPlanName">
                You requested to change {{ inAdminState ? "this subscriber's" : 'your' }} vision plan from {{ subscriberSummary.effectiveVisionPlan }} to {{ subscriberVisionPlanName }}.
              </li>
              <li *ngIf="hasVision && subscriberSummary.effectiveVisionPlan == subscriberVisionPlanName">You have not made changes to {{ inAdminState ? "this subscriber's" : 'your' }} vision plan.</li>              

              <div *ngFor="let waiver of waiverMessages">
                <li *ngIf="(waiver.planTypeName === 'Dental' && hasDental) || (waiver.planTypeName === 'Medical' && hasMedical) || (waiver.planTypeName === 'Vision' && hasVision)">
                  You are choosing to waive {{ waiver.planTypeName }} coverage for yourself and all dependents. Please be aware of the following PEBB Program rules:
                  <ol>
                    <li>You must be enrolled in employer-based group medical, Medicare or a TRICARE plan to waive your enrollment in PEBB medical.</li>
                    <li>
                      Your next opportunity to enroll in PEBB {{waiver.planTypeName}} coverage is during the next annual open enrollment unless you or your dependent experience a special open
                      enrollment event that allows you to enroll in medical.
                    </li>
                  </ol>
                </li>
              </div>
            </ul>
            <div *ngIf="subscriberSummary?.subscriberDualProgramEnrolled">
              <h3 fxFlexFill class="hca-error-msgbox">
                <b>Please note</b>, the subscriber is currently enrolled in the {{subscriberSummary?.agencyCode == 'SEBB' ? 'PEBB' : 'SEBB'}} program. 
                Dual enrollment between programs is not allowed. Submitting this enrollment will terminate the coverage in {{subscriberSummary?.agencyCode == 'SEBB' ? 'PEBB' : 'SEBB'}}
                for subscriber and any enrolled dependents effective {{dayjs(enrollmentPeriod.coverageEffectiveStartDate).subtract(1, 'day').toDate() | date:'MM/dd/YYYY' }}
              </h3>
            </div>
          </div>
        </div>
        <div>
          <div class="hca-pdf-table-content info-container mgtp-medium-sm mgbt-medium-sm">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div fxFlex="20"><h4 style="text-align: center">Subscriber:</h4></div>
              <div fxFlex="20"><h4 style="text-align: center">Coverage effective date:</h4></div>
              <div *ngIf="hasMedical" [fxFlex]="hasMedical && hasDental ? 20 : 40">
                <h4 style="text-align: center">Medical Plan:</h4>
              </div>
              <div *ngIf="hasDental" [fxFlex]="hasMedical && hasDental ? 20 : 40">
                <h4 style="text-align: center">Dental Plan:</h4>
              </div>
              <div *ngIf="hasVision" [fxFlex]="20">
                <h4 style="text-align: center">Vision Plan:</h4>
              </div>
            </div>
            <div *ngFor="let member of subscriberSummary.memberSummary; let i = index; let isOdd=odd; let isEven=even"
              fxLayout="row" fxLayoutAlign="space-between end" [class.tableOdd]="isOdd" [class.tableEven]="isEven"
              class="force-standard-font"
              style="padding-bottom: 5px; padding-top: 5px;"
              >
              <div fxFlex="20">
                <h5 style="text-align: center">{{ member.lastName }}, {{ member.firstName }}</h5>
                <h5 style="text-align: center">DOB - {{ member.birthDate | date: 'MM/dd/yyyy' }}</h5>
              </div>
              <div fxFlex="20">
                <h5 style="text-align: center">{{ getEffectiveCoverageDate(member, i) | date: 'MM/dd/yyyy' }}</h5>
              </div>
              <div *ngIf="hasMedical" [fxFlex]="hasMedical && hasDental ? 20 : 40">
                <h5 style="text-align: center">{{ memberMedicalPlan(member) }}</h5>
              </div>
              <div *ngIf="hasDental" [fxFlex]="hasMedical && hasDental ? 20 : 40">
                <h5 style="text-align: center">{{ memberDentalPlan(member) }}</h5>
              </div>
              <div *ngIf="hasVision" [fxFlex]="20">
                <h5 style="text-align: center">{{ memberVisionPlan(member) }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
